import { createContext, useContext, useState } from "react";

const dict = {
  fr: {
    nav_boat: "Le bateau", nav_excursions: "Excursions", nav_book: "Réserver", nav_admin: "Espace admin",
    hero_kicker: "Blue Army — Location bateau privé",
    hero_title: "Vivez le lagon de Maurice en toute exclusivité",
    hero_sub: "Évadez-vous à bord du Blue Army, notre speedboat de 28 pieds avec skipper professionnel inclus. Confort premium et performance au rendez-vous pour vos explorations dans le Nord et l'Ouest de l'île.",
    hero_cta: "Faire une demande", hero_cta2: "Voir les excursions",
    hero_promise: "Réponse sous 24 h · Acompte en ligne via Juice",
    loc_label: "Location", loc_boat: "Bateau entier", loc_from: "À partir de Rs 25 000", loc_min: "Minimum : journée",
    incl_title: "Tout est prévu pour votre tranquillité d'esprit",
    incl: [
      ["Deux skippers professionnels", "Des experts locaux et passionnés qui vous emmènent sur les meilleurs spots."],
      ["Carburant inclus", "Aucune surprise : le prix annoncé est le prix final."],
      ["Sécurité optimale", "Équipement de pointe, vérifié et complet avant chaque départ. Surveillance pendant la baignade."],
      ["Matériel de snorkeling", "Masques et tubas fournis pour explorer les fonds marins en toute liberté."],
    ],
    exc_kicker: "Île aux Bénitiers — Jolly Roger LTD",
    exc_title: "Nos excursions exclusives",
    exc1_label: "Expédition 1", exc1_name: "L'Expérience Bénitier Classique",
    exc1_lead: "Une journée inoubliable, tout inclus, au cœur du lagon.",
    exc1_points: [
      ["Rencontre magique", "Observation des dauphins dans leur habitat naturel."],
      ["Snorkeling d'exception", "Exploration des eaux cristallines de Crystal Rock."],
      ["Festin à bord", "Déjeuner barbecue avec poisson frais du jour, poulet, salades et boissons inclus."],
    ],
    exc1_option: "Option Prestige : surclassez votre repas avec un plateau de langouste.",
    exc2_label: "Expédition 2", exc2_name: "Sunset Champagne",
    exc2_lead: "L'heure magique : célébrez un moment unique lors d'une croisière privée au coucher du soleil.",
    exc2_points: [
      ["Spectacle naturel", "Vue panoramique imprenable sur les couleurs changeantes du lagon."],
      ["Ambiance feutrée", "Un moment privilégié, idéal pour un anniversaire ou une demande en mariage."],
      ["Gourmandise", "Plateau apéritif froid haut de gamme."],
    ],
    exc2_option: "Option Prestige : bouteille de champagne français pour trinquer face au soleil couchant.",
    choose: "Choisir cette excursion",
    how_title: "Réservez votre évasion en 3 étapes simples",
    how: [["Votre demande", "Choisissez votre date, votre excursion et vos options gourmandes via notre formulaire."], ["Validation éclair", "Nous vérifions la disponibilité et vous envoyons une confirmation détaillée sous 24 heures."], ["Réservation sécurisée", "Réglez votre acompte en toute simplicité via Juice pour bloquer définitivement votre date."]],
    form_title: "Prêt à larguer les amarres ?",
    form_sub: "Une question, une demande sur-mesure (anniversaire, demande en mariage, sortie d'entreprise) ? Contactez-nous sans engagement. Notre équipe vous répond par e-mail ou WhatsApp en moins de 24 heures.",
    cta_whatsapp: "Nous écrire sur WhatsApp", wa_prefill: "Bonjour Jolly Roger, je souhaite des informations sur une sortie en bateau.", cta_email: "Nous écrire par e-mail",
    f_excursion: "Excursion", f_date: "Date souhaitée", f_guests: "Nombre de personnes", f_options: "Options",
    f_name: "Nom complet", f_email: "E-mail", f_phone: "Téléphone / WhatsApp", f_message: "Message (facultatif)",
    f_submit: "Envoyer ma demande", f_sending: "Envoi…",
    f_booked: "Cette date vient d'être réservée, merci d'en choisir une autre.",
    f_pick_date: "Choisissez une date", cal_free: "Disponible", cal_booked: "Déjà réservé",
    f_error: "Merci de vérifier les champs du formulaire.",
    exc_names: { location: "Location bateau entier (journée)", classic: "L'Expérience Bénitier Classique", sunset: "Sunset Champagne" },
    options: { langouste: "Plateau de langouste (Prestige)", repas_froid: "Repas froid haut de gamme", plateau_fruits_mer: "Plateau fruits de mer", champagne: "Bouteille de champagne français (Prestige)", plateau_aperitif: "Plateau apéritif froid haut de gamme" },
    sent_title: "Demande envoyée !",
    sent_body: "Merci ! Vous allez recevoir un e-mail de confirmation. Nous vous répondons sous 24 heures.",
    sent_track: "Suivre ma demande",
    footer_contact: "Contact",
    footer_area: "Nord & Ouest Maurice · Skipper inclus",
    tr_title: "Votre réservation",
    tr_loading: "Chargement…", tr_notfound: "Réservation introuvable.",
    status: { pending: "En attente de réponse", approved: "Acceptée — acompte à régler", payment_submitted: "Paiement en vérification", confirmed: "Confirmée", declined: "Non disponible", cancelled: "Annulée" },
    tr_pending: "Nous avons bien reçu votre demande. Réponse au plus tard le",
    tr_total: "Prix total", tr_deposit: "Acompte à régler", tr_balance: "Solde le jour de la sortie",
    pay_title: "Payer l'acompte avec Juice",
    pay_steps: ["Ouvrez l'application MCB Juice", "Choisissez « Transfert » vers le numéro ci-dessous", "Indiquez la référence de réservation en libellé", "Saisissez ici la référence de transaction reçue"],
    pay_number: "Numéro Juice", pay_holder: "Bénéficiaire", pay_ref_label: "Libellé à indiquer",
    pay_tx: "Référence de transaction Juice", pay_payer: "Nom du payeur", pay_submit: "J'ai payé l'acompte",
    pay_pending_num: "Le numéro Juice vous sera communiqué par WhatsApp.",
    pay_submitted: "Merci ! Nous vérifions la réception de votre acompte et confirmons votre réservation par e-mail.",
    tr_confirmed: "Votre sortie est confirmée. À bientôt à bord !",
    tr_declined: "Désolés, nous ne pouvons pas assurer cette date. Contactez-nous sur WhatsApp pour une alternative.",
    tr_note: "Message du capitaine",
    tr_cancelled: "Cette réservation a été annulée. Pour toute question, contactez-nous sur WhatsApp ou par e-mail.",
    back_home: "Retour au site",
  },
  en: {
    nav_boat: "The boat", nav_excursions: "Excursions", nav_book: "Book", nav_admin: "Admin",
    hero_kicker: "Blue Army — Private boat charter",
    hero_title: "Experience the Mauritian lagoon in total exclusivity",
    hero_sub: "Escape aboard Blue Army, our 28-foot speedboat with a professional skipper included. Premium comfort and performance for your explorations of the island's North and West.",
    hero_cta: "Request a booking", hero_cta2: "See excursions",
    hero_promise: "Reply within 24h · Online deposit via Juice",
    loc_label: "Charter", loc_boat: "Whole boat", loc_from: "From Rs 25,000", loc_min: "Minimum: full day",
    incl_title: "Everything is taken care of for your peace of mind",
    incl: [
      ["Two professional skippers", "Passionate local experts who take you to the best spots."],
      ["Fuel included", "No surprises: the price quoted is the final price."],
      ["Optimal safety", "State-of-the-art equipment, fully checked before every departure. Supervision while swimming."],
      ["Snorkeling gear", "Masks and snorkels provided to explore the seabed freely."],
    ],
    exc_kicker: "Île aux Bénitiers — Jolly Roger LTD",
    exc_title: "Our exclusive excursions",
    exc1_label: "Expedition 1", exc1_name: "The Bénitier Classic Experience",
    exc1_lead: "An unforgettable all-inclusive day in the heart of the lagoon.",
    exc1_points: [
      ["A magical encounter", "Dolphin watching in their natural habitat."],
      ["Exceptional snorkeling", "Explore the crystal-clear waters of Crystal Rock."],
      ["A feast on board", "BBQ lunch with fresh catch of the day, chicken, salads and drinks included."],
    ],
    exc1_option: "Prestige option: upgrade your meal with a lobster platter.",
    exc2_label: "Expedition 2", exc2_name: "Sunset Champagne",
    exc2_lead: "The magic hour: celebrate a unique moment on a private sunset cruise.",
    exc2_points: [
      ["A natural spectacle", "Breathtaking panoramic views of the lagoon's changing colours."],
      ["Intimate atmosphere", "A special moment, perfect for a birthday or a marriage proposal."],
      ["Indulgence", "Premium cold aperitif platter."],
    ],
    exc2_option: "Prestige option: a bottle of French champagne to toast the setting sun.",
    choose: "Choose this excursion",
    how_title: "Book your getaway in 3 simple steps",
    how: [["Your request", "Choose your date, your excursion and your gourmet options using our form."], ["Fast approval", "We check availability and send you a detailed confirmation within 24 hours."], ["Secure booking", "Simply pay your deposit via Juice to lock in your date."]],
    form_title: "Ready to cast off?",
    form_sub: "A question or a tailor-made request (birthday, marriage proposal, company outing)? Contact us with no commitment. Our team replies by email or WhatsApp within 24 hours.",
    cta_whatsapp: "Message us on WhatsApp", wa_prefill: "Hello Jolly Roger, I would like information about a boat trip.", cta_email: "Email us",
    f_excursion: "Excursion", f_date: "Preferred date", f_guests: "Number of guests", f_options: "Options",
    f_name: "Full name", f_email: "Email", f_phone: "Phone / WhatsApp", f_message: "Message (optional)",
    f_submit: "Send my request", f_sending: "Sending…",
    f_booked: "This date has just been booked, please choose another one.",
    f_pick_date: "Pick a date", cal_free: "Available", cal_booked: "Already booked",
    f_error: "Please check the form fields.",
    exc_names: { location: "Full boat charter (day)", classic: "The Bénitier Classic Experience", sunset: "Sunset Champagne" },
    options: { langouste: "Lobster platter (Prestige)", repas_froid: "Premium cold meal", plateau_fruits_mer: "Seafood platter", champagne: "Bottle of French champagne (Prestige)", plateau_aperitif: "Premium cold aperitif platter" },
    sent_title: "Request sent!",
    sent_body: "Thank you! You will receive a confirmation email. We reply within 24 hours.",
    sent_track: "Track my request",
    footer_contact: "Contact",
    footer_area: "North & West Mauritius · Skipper included",
    tr_title: "Your booking",
    tr_loading: "Loading…", tr_notfound: "Booking not found.",
    status: { pending: "Awaiting reply", approved: "Accepted — deposit due", payment_submitted: "Payment being checked", confirmed: "Confirmed", declined: "Not available", cancelled: "Cancelled" },
    tr_pending: "We have received your request. Reply at the latest by",
    tr_total: "Total price", tr_deposit: "Deposit due", tr_balance: "Balance on the day",
    pay_title: "Pay the deposit with Juice",
    pay_steps: ["Open the MCB Juice app", "Choose “Transfer” to the number below", "Add the booking reference as description", "Enter the transaction reference here"],
    pay_number: "Juice number", pay_holder: "Beneficiary", pay_ref_label: "Description to add",
    pay_tx: "Juice transaction reference", pay_payer: "Payer name", pay_submit: "I have paid the deposit",
    pay_pending_num: "The Juice number will be sent to you on WhatsApp.",
    pay_submitted: "Thank you! We are checking your deposit and will confirm your booking by email.",
    tr_confirmed: "Your trip is confirmed. See you on board!",
    tr_declined: "Sorry, we cannot operate on this date. Contact us on WhatsApp for an alternative.",
    tr_note: "Message from the captain",
    tr_cancelled: "This booking has been cancelled. For any question, contact us on WhatsApp or by email.",
    back_home: "Back to site",
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("jr_lang") || "fr");
  const setLang = (l) => { localStorage.setItem("jr_lang", l); setLangState(l); };
  return <LangContext.Provider value={{ lang, setLang, t: dict[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

export const CONTACT = { whatsapp: "+33 6 69 49 05 05", whatsappLink: "https://wa.me/33669490505", email: "jckrose@icloud.fr" };

export const EXC_OPTIONS = {
  location: [],
  classic: ["langouste", "repas_froid", "plateau_fruits_mer"],
  sunset: ["champagne", "plateau_aperitif"],
};

export const formatRs = (n) => `Rs ${Math.round(n || 0).toLocaleString("fr-FR")}`;
